function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkwayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "\\u884C\\u4EBA_1",
    "data-name": "\\u884C\\u4EBA 1",
    style: {
      fill: "none",
      strokeWidth: 5,
      stroke: "#04C0C2",
      fillRule: "evenodd"
    },
    d: "M38.874,21.426L34.884,20.4l4.333,10.41,3.877,13.728L48,54.258l-3.763,2.059L38.76,46.593,33.515,36.3l-5.856,7.449L27,56.864,22.951,57,22.91,41.217,28.5,32.522l-2.053-8.694L22.529,26.66l-8.058,3L13,26.6l8.8-4.487,2.932-6.174,1.824-1.944,3.307-1.03,3.992,0.572,8.782,5.124,2.735,9.519-3.307,1.259ZM26.243,12.662a3.828,3.828,0,1,1,3.816-3.828A3.822,3.822,0,0,1,26.243,12.662Z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkwayIcon);
export default __webpack_public_path__ + "static/media/walkway-icon.8306b29e4c49a400aee1e767e4b43400.svg";
export { ForwardRef as ReactComponent };